import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const sendEmail = async (data = {}) => axiosRequest({
  url: '/v1/email/send',
  method: 'POST',
  data,
  headers: defaultHeaders,
});

const getTemplate = async (data = {}) => axiosRequest({
  url: '/v1/email/getTemplateById',
  method: 'POST',
  data,
  headers: defaultHeaders,
});

export { sendEmail, getTemplate };
